import { render, staticRenderFns } from "./OtherPropertyFireInsurance.vue?vue&type=template&id=1f358668"
import script from "./OtherPropertyFireInsurance.vue?vue&type=script&lang=js"
export * from "./OtherPropertyFireInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports